import React from 'react';
import PropTypes from 'prop-types';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { colors, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {closeAlert } from 'actions'
import { useSelector, useDispatch } from 'react-redux';

const useStyles = makeStyles(theme => ({
  message: {
    whiteSpace: 'pre-wrap',
    maxHeight: '90vh'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2)
  },
  content: {
    padding: theme.spacing(0, 2),
    maxWidth: 720,
    margin: theme.spacing(2, 0)
  },
  contact: {
    margin: theme.spacing(3, 0)
  },
  actions: {
    backgroundColor: colors.grey[100],
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));

const TextareaDialog = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { open, type, typeProps } = useSelector(state => state.alert);
  const {title, buttonText, InputProps = {}, validate, resolve, reject} = typeProps;

  const [text, setText] = React.useState('');
  const [error, setError] = React.useState('');

  const handleClose = (event, reason) => {
    setText('');
    setError('');
    if (reason === 'backdropClick') {
      reject();
    }
    dispatch(closeAlert())
  };

  const handleSubmit = () => {
    const err = validate ? validate(text):null;
    if(err !== null) {
      setError(err);
      return;
    }
    resolve(text);
    handleClose();
  }

  const isOpen = type === 'textarea' && open

  return (
    <Dialog
      TransitionComponent={Slide}
      fullWidth
      maxWidth="sm"
      onClose={handleClose}
      open={isOpen}
    >
      <div className={classes.header}>
        <Typography variant="h3">
          {title}
        </Typography>
      </div>
      <Divider />
      <div className={classes.content}>
        <TextField
          error={!!error}
          helperText={error}
          onChange={(e) => setText(e.target.value)}
          size='small'
          type='text'
          variant='outlined'
          {...InputProps}
        />
      </div>
      <div className={classes.actions}>
        <Button
          color='primary'
          onClick={handleSubmit}
          variant="contained"
        >
          {buttonText || 'Submit'}
        </Button>
      </div>
    </Dialog>
  );
}

TextareaDialog.propTypes = {
  className: PropTypes.string
};

export default TextareaDialog;
